import { Link, NavLink } from "react-router-dom";
import React, { useState, useEffect, Fragment, useRef } from "react";
import { utils, ResponseCode } from "../../utils/Utils";
import Leftpanel from "../../Layout/Sidebar/LeftPanel";
import NoRights from "../Common/NoRights";
import $ from "jquery";
import { AsyncAjaxGet, AsyncAjaxPost, AsyncAjaxPatch } from "../Common/AsyncAjaxService";
import Loader from "../Common/Loader";
import { useSelector } from 'react-redux'
import Alert from "react-bootstrap/Alert";
import { useParams } from "react-router-dom";
import { useDispatch } from 'react-redux'
import useGenerateToken from "components/Hook/useGenerateToken";
import {
     SuccessPurchaseDomain
} from '../Slice/Business';
import useSession from "components/Hook/useSession";

const Usedomain = (props) => {

     const { ReactBusinessId, ReactUserID, BusinessID, UserID, WebsiteBuilderParentWebsite, IsViewAllowed, IsModifyAllowed } = useSelector((state) => state.Business);
     const dispatch = useDispatch();
     const { StyleId, LayoutId } = useParams();
     const DomainInputRef = useRef(null);
     const firstRender = useRef(true);

     const VagaroAPIEnum = {
          GetDomainProvider: BusinessID + "/domains/domainproviders",
          ConnectOwnDomain: "merchants/" + BusinessID + "/domains",
          DomainAvailability: BusinessID + "/domains/",
          GetPurchasedDomainList: "merchants/" + BusinessID + "/domains/purchased",
          ConnectedDomain: "merchants/" + BusinessID + "/domains/",
          GetConnectionData: "merchants/" + BusinessID + "/domains/connectiondataruntime",
     }

     const [isLoading, setLoading] = useState(false);
     const [domainList, setDomainList] = useState([]);
     const [selectedDomain, setSelectedDomain] = useState({ domainName: "", domainUrl: "" });

     const [otherDomainName, setOtherDomainName] = useState("");
     const connectedDomainName = useRef("");

     const [IsMessageOpen, setIsMessageOpen] = useState(false);
     const [Message, setMessage] = useState("");
     const [isValidDomainName, setIsValidDomainName] = useState(true);
     const [isExistDomain, setIsExistDomain] = useState(false);
     const [customDomainList, setCustomDomainList] = useState([]);
     const [connectiondata, setConnectionData] = useState([]);

     const CheckSession = async () => {
          setLoading(true);
          return await useSession(dispatch, BusinessID, UserID, (data) => {
               setLoading(false);
               if (data == true) {
                    if (ReactBusinessId > 0) {
                         GetDomainProvider();
                         domainSearchResultHeight();
                         window.addEventListener('resize', domainSearchResultHeight);
                    }
                    CheckLogin();
               }
          });
     }

     useEffect(() => {
          utils.SetPageTitle("Use Domain");
          CheckSession();
     }, [BusinessID]);

     useEffect(() => {
          if (IsMessageOpen) {
               window.setTimeout(() => {
                    setIsMessageOpen(false);
               }, 3000)
          }
     }, [IsMessageOpen])

     useEffect(() => {
          if (firstRender.current) {
               DomainInputRef.current.focus();
               firstRender.current = false;
          }
     }, [])

     const CheckLogin = () => {
          if (ReactBusinessId === -2) {
               window.location.replace(WebsiteBuilderParentWebsite + "login");
          }
     }

     const _handleKeyDown = (e) => {
          if (e.key === "Enter") {
               if (e.target.value !== "") {
                    GetDomainAvailability(e.target.value);
                    e.target.blur();
               }
          }
     };

     const PurchasedDomainList = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               await AsyncAjaxGet(
                    VagaroAPIEnum.GetPurchasedDomainList,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        setCustomDomainList(data.data.data);
                                   }
                                   else {
                                        setCustomDomainList([]);
                                   }
                              }
                              setLoading(false);
                         }
                         catch (error) {
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Purchased Domain List",
                                   BusinessID,
                                   ""
                              );
                              setLoading(false);
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Purchased Domain List",
                              BusinessID,
                              ""
                         );
                         setLoading(false);
                    }
               );
          }
          else {
               utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
          }
     };

     const GetDomainAvailability = async (DomainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               $("#forautofocus").blur();
               setLoading(true);
               await AsyncAjaxGet(
                    VagaroAPIEnum.DomainAvailability + DomainName + "/available",
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        var domainData = data.data.data;
                                        if (domainData.available == false) {
                                             setIsExistDomain(true);
                                             setLoading(false);
                                             $("#forautofocus").focus();
                                        }
                                        else {
                                             setIsExistDomain(false);
                                             setLoading(false);
                                             utils.ShowAlert("Alert!", "Sorry, " + DomainName + " domain is not available.", "OpenDialog", true);
                                        }
                                   }
                                   else {
                                        setIsExistDomain(false);
                                        setLoading(false);
                                        utils.ShowAlert("Alert!", "Sorry, " + DomainName + " domain is not available.", "OpenDialog", true);
                                   }
                              }
                              else {
                                   setIsExistDomain(false);
                                   setLoading(false);
                                   utils.ShowAlert("Alert!", "Sorry, " + DomainName + " domain is not available.", "OpenDialog", true);
                              }
                         }
                         catch (error) {
                              setLoading(false);
                              setIsExistDomain(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Domain Availability",
                                   BusinessID,
                                   ""
                              );
                              utils.ShowAlert("Alert!", "Sorry, " + DomainName + " domain is not available.", "OpenDialog", true);
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         setIsExistDomain(false);
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Domain Availability",
                              BusinessID,
                              ""
                         );
                         utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     };

     const GetDomainProvider = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               await AsyncAjaxGet(
                    VagaroAPIEnum.GetDomainProvider,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        var DataSorted = data.data.data.sort((a, b) => { return a.domainId - b.domainId })
                                        setDomainList(data.data.data);
                                        setSelectedDomain({ domainName: DataSorted[0].domainName, domainUrl: DataSorted[0].domainUrl });
                                        PurchasedDomainList();
                                   }
                                   else {
                                        setLoading(false);
                                   }
                              }
                              else {
                                   setLoading(false);
                              }

                         } catch (error) {
                              setLoading(false);
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     };

     const Domainamefind = customDomainList.find(obj => obj.domainName.toLowerCase().trim() === otherDomainName.toLowerCase().trim());

     const ConnectDomain = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Message", "Sorry, You don't have permission to connect domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    const Requestdata = {};
                    Requestdata.UserID = UserID;
                    await AsyncAjaxPatch(
                         VagaroAPIEnum.ConnectedDomain + domainName + "/connect",
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   connectedDomainName.current = domainName;
                                   setOtherDomainName("");
                                   setIsExistDomain(false);
                                   GetConnectionData();
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Connect Domain",
                                        domainName,
                                        ""
                                   );
                              }
                         },
                         function OnError(error) {
                              setLoading(false);
                              if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Connect Domain : " + error.response.data.errors.exception,
                                        domainName,
                                        ""
                                   );
                                   utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                              }
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     const ConnectOwnDomain = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Message", "Sorry, You don't have permission to connect own domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    if (Domainamefind !== undefined && Domainamefind !== null && Domainamefind !== '' && Domainamefind.domainName === otherDomainName) {
                         setIsMessageOpen(true);
                         setMessage(otherDomainName + " domain is already connected with this business. Please use different domain.");
                    }
                    else {
                         if ((otherDomainName.trim() === "" || otherDomainName === null || typeof otherDomainName === undefined)) {
                              setIsValidDomainName(false);
                              return;
                         }
                         else {
                              setIsValidDomainName(true);
                         }
                         setLoading(true);
                         const Requestdata = {};
                         Requestdata.userId = UserID;
                         Requestdata.provider = utils.Validate(selectedDomain) && utils.Validate(selectedDomain.domainName) ? selectedDomain.domainName : "other";
                         await AsyncAjaxPost(
                              VagaroAPIEnum.ConnectOwnDomain + "/" + otherDomainName.trim().toLowerCase() + "/connectown",
                              Requestdata,
                              access_token,
                              function onSuccess(data) {
                                   try {
                                        if (
                                             data != null &&
                                             data.data != null &&
                                             data.data.responseCode == ResponseCode.Success
                                        ) {
                                             if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                                  connectedDomainName.current = "";
                                                  ConnectDomain(otherDomainName.trim().toLowerCase());
                                                  dispatch(SuccessPurchaseDomain());
                                             }
                                             else {
                                                  setLoading(false);
                                             }
                                        }
                                        else if (
                                             data != null &&
                                             data.data != null &&
                                             data.data.responseCode == ResponseCode.RecordExists
                                        ) {
                                             utils.ShowAlert("Alert!", "This domain is already connected with another Vagaro business. Please use different domain.", "OpenDialog", true);
                                             setLoading(false);
                                        }
                                        else {
                                             setLoading(false);
                                        }
                                   } catch (error) {
                                        setLoading(false);
                                        utils.appInsightTrack(
                                             ReactBusinessId,
                                             ReactUserID,
                                             "Save Other Domain",
                                             otherDomainName,
                                             ""
                                        );
                                   }
                              },
                              function OnError() {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Save Other Domain",
                                        otherDomainName,
                                        ""
                                   );
                                   utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                              }
                         );
                    }
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     };

     const UseDomainValidation = (DomainName) => {
          setOtherDomainName(DomainName);
          setIsExistDomain(false);
          if (DomainName == null) {
               setIsValidDomainName(false);
          }
          else { setIsValidDomainName(true); }
     }

     const RemoveFilters = () => {
          setOtherDomainName("");
          setIsExistDomain(false);
     }

     const GetConnectionData = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               if (utils.Validate(connectedDomainName.current)) {
                    setLoading(true);
                    await AsyncAjaxGet(
                         VagaroAPIEnum.GetConnectionData + "/" + connectedDomainName.current.trim().toLowerCase(),
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null) {
                                             setConnectionData(data.data.data);
                                             setLoading(false);
                                             var contorys = $(".copied-text-blue");
                                             if (contorys.length > 0) {
                                                  $.grep(contorys, (ele) => {
                                                       ele.classList.remove("copied-text-blue");
                                                  })
                                             }
                                        }
                                        else {
                                             setConnectionData([]);
                                             setLoading(false);
                                        }
                                   }
                                   setLoading(false);
                                   $("#forautofocus").focus();
                                   domainSearchResultHeight();
                              }
                              catch (error) {
                                   setLoading(false);
                                   $("#forautofocus").focus();
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Get Collection Data",
                                        BusinessID,
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              $("#forautofocus").focus();
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Collection Data",
                                   BusinessID,
                                   ""
                              );
                              utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                         }
                    );
               }
               else {
                    setLoading(false);
               }
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     };

     const domainSearchResultHeight = (e) => {

          var wHeight = $(window).height();
          var titleHeight
          if ($(".domain-section-title").length) {
               titleHeight = $(".domain-section-title").outerHeight(true);
          } else {
               titleHeight = 0;
          }

          var tabHeight
          if ($(".domain-section-title").length) {
               tabHeight = $(".domain-section-title").outerHeight(true);
          } else {
               tabHeight = 0;
          }
          var actionbtn
          if ($(".domain-actions").length) {
               actionbtn = $(".domain-actions").outerHeight(true);

          } else {
               actionbtn = 0;
          }

          var builindomain
          if ($(".jsbuiltin-domains").length) {
               builindomain = $(".jsbuiltin-domains").outerHeight(true);

          } else {
               builindomain = 0;
          }


          var calCardWrapperHeight = wHeight - titleHeight - tabHeight - actionbtn - builindomain - 100;
          $(".purchasedDomainslist").css("max-height", calCardWrapperHeight);

     }
     const copyToClipboard = (d) => {
          var contorys = $(".copied-text-blue");
          if (contorys.length > 0) {
               $.grep(contorys, (ele) => {
                    ele.classList.remove("copied-text-blue");
               })
          }
          if (d !== "") {
               navigator.clipboard.writeText(d)
          }
     }
     return (
          <Fragment>
               {isLoading && <Loader />}
               <div className={ReactBusinessId <= 0 ? "all-content-container no-access-main-content-wrapper" : "all-content-container main-content-wrapper"}>
                    {!props.inEditor &&
                         <Leftpanel activateTab={"GeneralSetting"} activatePage={"Domain"} />
                    }
                    {(() => {
                         if (ReactBusinessId === 0) {
                              return (
                                   <Fragment><NoRights /></Fragment>
                              )
                         } else {
                              return (
                                   ReactBusinessId > 0 &&
                                   <Fragment>
                                        <div className="page-root">
                                             <div className="page-content container">
                                                  {IsMessageOpen && (otherDomainName.trim() === "" || otherDomainName === null || typeof otherDomainName === undefined) &&
                                                       <Alert isOpen={IsMessageOpen} variant="success" className="vg-alert-strip vg-passive">
                                                            <i class="fas fa-check-circle"></i> {Message}
                                                       </Alert>
                                                  }
                                                  {IsMessageOpen && (Domainamefind !== undefined && Domainamefind !== null && Domainamefind !== '' && Domainamefind.domainName === otherDomainName) &&
                                                       <Alert isOpen={IsMessageOpen} variant="warning" className="vg-alert-strip vg-passive" style={{ backgroundColor: "#ff9f08", color: "white" }}>
                                                            <i class="fa fa-exclamation-triangle" Style="font-size:20px;color:white"></i> {Message}
                                                       </Alert>
                                                  }
                                                  <div className="getadomain-wrapper usedomainiown">
                                                       <div className="domain-section-title widthback py-t16">
                                                            {!props.inEditor ? <NavLink className="back-arrow domain-back" to={{ pathname: `${'/business/' + StyleId + "/" + LayoutId + "/domain"}` }}></NavLink>
                                                                 :
                                                                 <div className="back-arrow domain-back" style={{ cursor: "pointer" }}
                                                                      onClick={() => {
                                                                           props.setMenu && props.setMenu(1);
                                                                      }}
                                                                 ></div>}
                                                            Use a Domain I Own
                                                       </div>
                                                       <div className={`get-domain-search  ${isExistDomain && "has_selecteddomain"}  ${!isValidDomainName && "form-row-invalid"}`}>
                                                            {/*  <span className="domain-search-icon">{isExistDomain ? "" : ""}</span> */}
                                                            <input ref={DomainInputRef} className="form-control domain-search-control-existing-domain" type="text" autoComplete="off" placeholder="Enter Domain Name" onKeyDown={_handleKeyDown} onChange={(e) => UseDomainValidation(e.target.value = e.target.value.replace(/[^a-zA-Z0-9\-_\.]/g, ''))} defaultValue={otherDomainName} value={otherDomainName} id={"forautofocus"} />
                                                            {otherDomainName.length > 0 &&
                                                                 <div onClick={RemoveFilters} className="clear-domain-search"></div>
                                                            }
                                                       </div>
                                                       {isExistDomain &&
                                                            <Fragment>
                                                                 <div className="domain-provider">
                                                                      <div className="form-group">
                                                                           <label className="">Domain Provider :</label>
                                                                           <div className="domain-provider-controls form-row">
                                                                                <div className="domain_provider_dropdown dropdownfoucs vg-wb-select">
                                                                                     <select className="select-domain-provider form-control"
                                                                                          id="jsServerProvider" onChange={(e) => setSelectedDomain({ domainName: $("#jsServerProvider option:selected").text(), domainUrl: e.target.value })}>
                                                                                          {domainList.map((d) =>
                                                                                               <option selected={d.domainId === 1 ? "selected" : ""} value={d.domainUrl}>{d.domainName}</option>
                                                                                          )}
                                                                                     </select>
                                                                                </div>
                                                                                <div className="domainui_btns">
                                                                                     <a href="#" className="w-button w-button-primary" onClick={() => ConnectOwnDomain()}>Connect Domain</a>
                                                                                </div>
                                                                           </div>
                                                                      </div>
                                                                 </div>
                                                                 <div className="domain-info">
                                                                      <div className="domain-section-title">To Connect Domain</div>
                                                                      <p>
                                                                           Check the requirements from your domain
                                                                           provider{
                                                                                selectedDomain.domainName !== "Other" &&
                                                                                <>{","} <Link target="_blank" to={selectedDomain.domainUrl}>{selectedDomain.domainName}</Link>{","}</>} to
                                                                           use your domain.{" "}
                                                                      </p>
                                                                 </div>
                                                            </Fragment>
                                                       }
                                                       {connectiondata.length > 0 &&
                                                            <Fragment>
                                                                 <br></br>
                                                                 <div className="domain-section-title">
                                                                      DNS Settings to Connect Your Domain
                                                                 </div>
                                                                 <div className="domain-section-body"><span>Update your domain provider settings to match the following information.</span><span className="refresh-list-icon" onClick={() => GetConnectionData()}><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z" /></svg></span></div>
                                                                 <div className="vg-table-wrapper py-t8 py-b24 tablscrollbdr">
                                                                      <div className="vg-table-bdr">
                                                                           <table className="table">
                                                                                <thead>
                                                                                     <tr>
                                                                                          <th>Domain</th>
                                                                                          <th>Type</th>
                                                                                          <th>Host</th>
                                                                                          <th>Required Value</th>
                                                                                          <th>Connection</th>
                                                                                     </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                     {connectiondata.length > 0 && connectiondata.map((d) => {
                                                                                          return (
                                                                                               <Fragment>
                                                                                                    <tr>
                                                                                                         <td data-lbl="Domain">{d.domainName}</td>
                                                                                                         <td data-lbl="Type">{d.recordType}</td>
                                                                                                         <td data-lbl="Host">{d.recordName}</td>
                                                                                                         <td className="word-break-td" data-lbl="Required Value">{d.recordValue == "Gathering information. It may take up to few minutes." ? <Fragment><span className="text-disconnected">Gathering information. It may take up to few minutes.</span></Fragment> : <Fragment>{d.recordValue} {d.recordValue !== "" && <div className="copytoclipboard icons" onClick={(e) => { copyToClipboard(d.recordValue); e.target.classList.add("copied-text-blue") }}><div ><i class="fal fa-copy"></i></div></div>}</Fragment>}</td>
                                                                                                         <td data-lbl="Connection">{d.status == true && <span className="text-connected">Connected</span>}
                                                                                                              {d.status == false && <span className="text-disconnected">Disconnected</span>}</td>
                                                                                                    </tr>
                                                                                               </Fragment>
                                                                                          )
                                                                                     })}
                                                                                </tbody>
                                                                           </table>
                                                                      </div>
                                                                 </div>
                                                            </Fragment>
                                                       }
                                                  </div>
                                             </div>
                                        </div>
                                   </Fragment>
                              )
                         }
                    })()}
               </div>
          </Fragment>
     );
};

export default Usedomain;
